import MonthReportTable from './MonthReportTable'
export default MonthReportTable
